// formerly "acquired"

const ARTWORK_FIELDS = [
  'id',
  'artist_id',
  'visa_status',
  'media_material_description',
  // 'conservator',
  // 'last_media_check',
  'created_at',
  // 'dimensions_formatted',
  'dim_height',
  'dim_width',
  'dim_depth',
  'dim_diameter',
  'edition_state',
  'certificate_new',
  'signature_new',
  'credit',
  'artwork_location',
  'top_photo_id',
  'type_of_work_id',
  'production_date_new',
  'acquisition_date',
  'ownership',
  'accession_number',
  'classification',
  'classification_new_id',
  'acquisition_source_id',
  'acquired',
  'deaccessioned',
  'deaccession_date',
  'location_notes',
  'artwork_location_id',
  'insurance_value',
  'insurance_value_currency',
  'purchased_price',
  'purchased_price_currency',
  'title',
  'subtitle',
  'tags',
  'artwork_todos',
  'top_photo',
  'width',
  'height',
  'full_name',
  'last_name',
  'sort_name',
  'location_name',
  'ownership_info',
  'dim_f_json',
  'acquisition_method',
  'acquisition_method_text',
  'purchase_price_text',
  'insurance_value_text',
  'import_date',
  'import_export_notes',
  'paid_in_country',
  'import_export_history',
  'name'
]

const TOOLBAR_MENU_ITEMS = [
  {
    icon: 'contacts',
    'icon-alt': 'contacts',
    text: 'Collections',
    children: [
      {
        icon: 'people',
        text: 'All Collections',
        path: '/artworks/ownership/all',
        shortkey: ['ctrl', 'c'],
        role: 'all_coll'
      },
      {
        icon: 'people',
        text: 'TBA21 Collection',
        path: '/artworks/ownership/collection',
        role: 'coll'
      },
      {
        icon: 'people',
        text: 'Gemini Masters Limited',
        path: '/artworks/ownership/gemini',
        role: 'gemini'
      },
      {
        icon: 'people',
        text: 'Gemini Collections Limited',
        path: '/artworks/ownership/geminiCL',
        role: 'geminiCL'
      },
      // {
      //   icon: "people",
      //   text: "Gemini Collections Deaccessioned",
      //   path: "/artworks/ownership/geminiCD",
      //   role: "geminiCD",
      // },
      {
        icon: 'people',
        text: 'Private Art Collection FTB',
        path: '/artworks/ownership/pacFvh',
        active: true,
        role: 'pacFvh'
      },
      {
        icon: 'people',
        text: 'Private Design Collection FTB',
        path: '/artworks/ownership/pdcFvh',
        role: 'pdcFvh'
      },
      {
        icon: 'people',
        text: 'Private Collection EH',
        path: '/artworks/ownership/pacEh',
        role: 'pacEh'
      },
      {
        icon: 'people',
        text: 'Private Collection GH',
        path: '/artworks/ownership/pacGh',
        role: 'pacGh'
      },
      {
        icon: 'people',
        text: 'Private Collection FH',
        path: '/artworks/ownership/pacFh',
        role: 'pacFh'
      },
      {
        icon: 'people',
        text: 'Private Art Collection MR',
        path: '/artworks/ownership/pacMr',
        role: 'pacMr'
      },
      {
        icon: 'people',
        text: 'Private Design Casa Austria',
        path: '/artworks/ownership/pcCA',
        role: 'pcCA'
      },
      {
        icon: 'people',
        text: 'Private Collection FT',
        path: '/artworks/ownership/pcFT',
        role: 'pcFT'
      },
      {
        icon: 'people',
        text: 'Deaccession',
        path: '/artworks/ownership/deaccession',
        role: 'deac'
      }
      // {
      //   icon: "people",
      //   text: "Old Masters",
      //   path: "/artworks/ownership/oldMasters",
      //   role: "old_masters",
      // },
      // {
      //   icon: "people",
      //   text: "Foreign Artworks",
      //   path: "/artworks/ownership/foreign",
      //   role: "foreign",
      // },
    ]
  },
  {
    icon: 'burst_mode',
    text: 'Commissions',
    path: '/artworks/ownership/commissions',
    role: 'commissions'
  },
  {
    icon: 'burst_mode',
    text: 'Non-TBA21',
    path: '/artworks/ownership/nonTba',
    role: 'nonTba'
  },
  {
    icon: 'burst_mode',
    text: 'TBA21 Academy Commissions',
    path: '/artworks/ownership/com_academy',
    role: 'com_academy'
  },
  // { icon: 'people', text: 'Lists', path: '/lists' },
  // {
  //   icon: "burst_mode",
  //   text: "Facts and Figures",
  //   path: "/facts",
  //   shortkey: ["ctrl", "f"]
  // },
  {
    icon: 'burst_mode',
    text: 'Lists',
    path: '/lists',
    shortkey: ['ctrl', 'l'],
    role: 'lists'
  },
  {
    icon: 'burst_mode',
    text: 'Selections',
    path: '/selections',
    shortkey: ['ctrl', 's'],
    role: 'selections'
  },
  {
    icon: 'todo',
    text: 'Todos',
    path: '/todos',
    role: 'todos'
  },
  {
    icon: 'people',
    text: 'Artists',
    path: '/artists',
    shortkey: ['ctrl', 'a'],
    role: 'artists'
  },
  {
    icon: 'contacts',
    text: 'Exhibitions',
    path: '/exhibitions',
    shortkey: ['ctrl', 'e'],
    role: 'exhibitions'
  },
  {
    icon: 'collections_bookmark',
    text: 'Artwork Series',
    path: '/artwork-series',
    role: 'exhibitions'
  },
  {
    icon: 'text',
    text: 'Texts',
    path: '/texts',
    role: 'texts'
  },
  {
    icon: 'burst_mode',
    text: 'Tags',
    path: '/tags',
    shortkey: ['ctrl', 't'],
    role: 'tags'
  },
  {
    icon: 'contact_phone',
    text: 'Contacts',
    path: '/contacts',
    shortkey: ['ctrl', 'o'],
    role: 'contacts',
    edit_only: true
  },
  {
    icon: 'location_city',
    text: 'Locations',
    path: '/locations',
    shortkey: ['ctrl', 'n'],
    role: 'locations'
  },
  {
    icon: 'people',
    text: 'CMS Users',
    path: '/users',
    shortkey: ['ctrl', 'u'],
    role: 'users',
    edit_only: true
  },
  {
    icon: 'settings',
    text: 'CMS Articles',
    path: '/articles',
    role: 'support',
    edit_only: true
  },
  {
    icon: 'public',
    'icon-alt': 'public',
    text: 'PUBLIC',
    role: 'support',
    edit_only: true,
    children: [
      { icon: 'description', text: 'Articles', path: '/public-articles', role: 'support' },
      { icon: 'settings', text: 'Settings', path: '/public-settings', role: 'support' }
    ]
  },
  // {
  //   icon: 'keyboard_arrow_up',
  //   'icon-alt': 'keyboard_arrow_down', text: 'Value Lists',
  //   children: [
  //     { icon: 'format_list_bulleted', text: 'Ownerships' },
  //     { icon: 'fiber_smart_record', text: 'Tags' },
  //     { icon: 'photo_size_select_actual', text: 'Artwork' }
  //   ]
  // },
  // {
  //   icon: "keyboard_arrow_up",
  //   "icon-alt": "keyboard_arrow_down",
  //   text: "Add new...",
  //   model: false,
  //   edit_only: true,
  //   children: [
  //     { icon: "people", text: "Artist", path: "/artists/new" },
  //     { icon: "art_track", text: "Artwork", path: "/artworks/new" },
  //     { icon: "person_add", text: "User", path: "/users/new" },
  //     { icon: "add_location", text: "Location", path: "/locations/new" },
  //     { icon: "person_add", text: "Contact", path: "/contacts/new" },
  //     { icon: "burst_mode", text: "CR", path: "/reports/new" },
  //     {
  //       icon: "burst_mode",
  //       text: "IM",
  //       path: "/reports/wizzard_instalation_manual",
  //     },
  //     { icon: "text", text: "Text", path: "/texts/new" },
  //   ],
  // },
  // {
  //   icon: 'keyboard_arrow_up',
  //   'icon-alt': 'keyboard_arrow_down',
  //   text: 'More',
  //   model: false,
  //   children: [
  //     { text: 'wip' },
  //     { text: 'Export' }
  //   ]
  // },
  {
    icon: 'keyboard_arrow_up',
    text: 'My Settings',
    path: '/account_settings',
    'icon-alt': 'keyboard_arrow_down'
    // children: [
    //   {
    //     icon: "account_circle",
    //     text: "Account info",
    //     path: "/account_settings",
    //     role: "contacts"
    //   },
    // {
    //   icon: "notifications",
    //   text: "Notifications",
    //   role: "contacts",
    //   path: "/notification_settings"
    // },
    //   { icon: "home", text: "Home Page", path: "/home_page_settings" }
    // ]
  }
  // { icon: 'history', text: 'Change History' },
  // { icon: 'chat_bubble', text: 'Send feedback' },
  // { icon: 'help', text: 'Help' }
  // { icon: 'phonelink', text: 'App downloads' },
] // end of toolbar menu items

const OWNERSHIP_STATUSES = [
  { id: 'nontba', value: 'nontba', name: 'Non-TBA' },
  { id: 'commission', value: 'commission', name: 'Commission TBA21' },
  { id: 'acquired', value: 'acquired', name: 'Acquired' },
  {
    id: 'com_academy',
    value: 'com_academy',
    name: 'Commission TBA21-Academy',
  },
]

const TYPES_OF_WORK = [
  { id: 5, value: 5, name: 'Architecture' },
  { id: 11, value: 11, name: 'Concept' },
  { id: 1, value: 1, name: 'Drawing | Work on paper' },
  { id: 7, value: 7, name: 'Film / Video' },
  { id: 6, value: 6, name: 'Installation' },
  // { id: 17, value: 17, name: 'Jewellery' },
  // { id: 12, value: 12, name: 'Metalworks' },
  { id: 4, value: 4, name: 'Object | Sculpture' },
  // { id: 14, value: 14, name: 'Oriental' },
  { id: 2, value: 2, name: 'Painting' },
  { id: 8, value: 8, name: 'Performance' },
  { id: 3, value: 3, name: 'Photo / Print' },
  // { id: 15, value: 15, name: 'Silverware' },
  { id: 9, value: 9, name: 'Sound' },
  { id: 16, value: 16, name: 'Textiles' }
  // { id: 13, value: 13, name: 'Vertu' }
]

const LANGUAGES = [
  { id: 1, name: 'English', 'iso_639-1': 'en', position: 1 },
  { id: 2, name: 'Afar', 'iso_639-1': 'aa', position: 2 },
  { id: 3, name: 'Abkhazian', 'iso_639-1': 'ab', position: 3 },
  { id: 4, name: 'Afrikaans', 'iso_639-1': 'af', position: 4 },
  { id: 5, name: 'Amharic', 'iso_639-1': 'am', position: 5 },
  { id: 6, name: 'Arabic', 'iso_639-1': 'ar', position: 6 },
  { id: 7, name: 'Assamese', 'iso_639-1': 'as', position: 7 },
  { id: 8, name: 'Aymara', 'iso_639-1': 'ay', position: 8 },
  { id: 9, name: 'Azerbaijani', 'iso_639-1': 'az', position: 9 },
  { id: 10, name: 'Bashkir', 'iso_639-1': 'ba', position: 10 },
  { id: 11, name: 'Belarusian', 'iso_639-1': 'be', position: 11 },
  { id: 12, name: 'Bulgarian', 'iso_639-1': 'bg', position: 12 },
  { id: 13, name: 'Bihari', 'iso_639-1': 'bh', position: 13 },
  { id: 14, name: 'Bislama', 'iso_639-1': 'bi', position: 14 },
  { id: 15, name: 'Bengali/Bangla', 'iso_639-1': 'bn', position: 15 },
  { id: 16, name: 'Tibetan', 'iso_639-1': 'bo', position: 16 },
  { id: 17, name: 'Breton', 'iso_639-1': 'br', position: 17 },
  { id: 18, name: 'Catalan', 'iso_639-1': 'ca', position: 18 },
  { id: 19, name: 'Corsican', 'iso_639-1': 'co', position: 19 },
  { id: 20, name: 'Czech', 'iso_639-1': 'cs', position: 20 },
  { id: 21, name: 'Welsh', 'iso_639-1': 'cy', position: 21 },
  { id: 22, name: 'Danish', 'iso_639-1': 'da', position: 22 },
  { id: 23, name: 'German', 'iso_639-1': 'de', position: 23 },
  { id: 24, name: 'Bhutani', 'iso_639-1': 'dz', position: 24 },
  { id: 25, name: 'Greek', 'iso_639-1': 'el', position: 25 },
  { id: 26, name: 'Esperanto', 'iso_639-1': 'eo', position: 26 },
  { id: 27, name: 'Spanish', 'iso_639-1': 'es', position: 27 },
  { id: 28, name: 'Estonian', 'iso_639-1': 'et', position: 28 },
  { id: 29, name: 'Basque', 'iso_639-1': 'eu', position: 29 },
  { id: 30, name: 'Persian', 'iso_639-1': 'fa', position: 30 },
  { id: 31, name: 'Finnish', 'iso_639-1': 'fi', position: 31 },
  { id: 32, name: 'Fiji', 'iso_639-1': 'fj', position: 32 },
  { id: 33, name: 'Faeroese', 'iso_639-1': 'fo', position: 33 },
  { id: 34, name: 'French', 'iso_639-1': 'fr', position: 34 },
  { id: 35, name: 'Frisian', 'iso_639-1': 'fy', position: 35 },
  { id: 36, name: 'Irish', 'iso_639-1': 'ga', position: 36 },
  { id: 37, name: 'Scots/Gaelic', 'iso_639-1': 'gd', position: 37 },
  { id: 38, name: 'Galician', 'iso_639-1': 'gl', position: 38 },
  { id: 39, name: 'Guarani', 'iso_639-1': 'gn', position: 39 },
  { id: 40, name: 'Gujarati', 'iso_639-1': 'gu', position: 40 },
  { id: 41, name: 'Hausa', 'iso_639-1': 'ha', position: 41 },
  { id: 42, name: 'Hindi', 'iso_639-1': 'hi', position: 42 },
  { id: 43, name: 'Croatian', 'iso_639-1': 'hr', position: 43 },
  { id: 44, name: 'Hungarian', 'iso_639-1': 'hu', position: 44 },
  { id: 45, name: 'Armenian', 'iso_639-1': 'hy', position: 45 },
  { id: 46, name: 'Interlingua', 'iso_639-1': 'ia', position: 46 },
  { id: 47, name: 'Interlingue', 'iso_639-1': 'ie', position: 47 },
  { id: 48, name: 'Inupiak', 'iso_639-1': 'ik', position: 48 },
  { id: 49, name: 'Indonesian', 'iso_639-1': 'in', position: 49 },
  { id: 50, name: 'Icelandic', 'iso_639-1': 'is', position: 50 },
  { id: 51, name: 'Italian', 'iso_639-1': 'it', position: 51 },
  { id: 52, name: 'Hebrew', 'iso_639-1': 'iw', position: 52 },
  { id: 53, name: 'Japanese', 'iso_639-1': 'ja', position: 53 },
  { id: 54, name: 'Yiddish', 'iso_639-1': 'ji', position: 54 },
  { id: 55, name: 'Javanese', 'iso_639-1': 'jw', position: 55 },
  { id: 56, name: 'Georgian', 'iso_639-1': 'ka', position: 56 },
  { id: 57, name: 'Kazakh', 'iso_639-1': 'kk', position: 57 },
  { id: 58, name: 'Greenlandic', 'iso_639-1': 'kl', position: 58 },
  { id: 59, name: 'Cambodian', 'iso_639-1': 'km', position: 59 },
  { id: 60, name: 'Kannada', 'iso_639-1': 'kn', position: 60 },
  { id: 61, name: 'Korean', 'iso_639-1': 'ko', position: 61 },
  { id: 62, name: 'Kashmiri', 'iso_639-1': 'ks', position: 62 },
  { id: 63, name: 'Kurdish', 'iso_639-1': 'ku', position: 63 },
  { id: 64, name: 'Kirghiz', 'iso_639-1': 'ky', position: 64 },
  { id: 65, name: 'Latin', 'iso_639-1': 'la', position: 65 },
  { id: 66, name: 'Lingala', 'iso_639-1': 'ln', position: 66 },
  { id: 67, name: 'Laothian', 'iso_639-1': 'lo', position: 67 },
  { id: 68, name: 'Lithuanian', 'iso_639-1': 'lt', position: 68 },
  { id: 69, name: 'Latvian/Lettish', 'iso_639-1': 'lv', position: 69 },
  { id: 70, name: 'Malagasy', 'iso_639-1': 'mg', position: 70 },
  { id: 71, name: 'Maori', 'iso_639-1': 'mi', position: 71 },
  { id: 72, name: 'Macedonian', 'iso_639-1': 'mk', position: 72 },
  { id: 73, name: 'Malayalam', 'iso_639-1': 'ml', position: 73 },
  { id: 74, name: 'Mongolian', 'iso_639-1': 'mn', position: 74 },
  { id: 75, name: 'Moldavian', 'iso_639-1': 'mo', position: 75 },
  { id: 76, name: 'Marathi', 'iso_639-1': 'mr', position: 76 },
  { id: 77, name: 'Malay', 'iso_639-1': 'ms', position: 77 },
  { id: 78, name: 'Maltese', 'iso_639-1': 'mt', position: 78 },
  { id: 79, name: 'Burmese', 'iso_639-1': 'my', position: 79 },
  { id: 80, name: 'Nauru', 'iso_639-1': 'na', position: 80 },
  { id: 81, name: 'Nepali', 'iso_639-1': 'ne', position: 81 },
  { id: 82, name: 'Dutch', 'iso_639-1': 'nl', position: 82 },
  { id: 83, name: 'Norwegian', 'iso_639-1': 'no', position: 83 },
  { id: 84, name: 'Occitan', 'iso_639-1': 'oc', position: 84 },
  { id: 85, name: '(Afan)/Oromoor/Oriya', 'iso_639-1': 'om', position: 85 },
  { id: 86, name: 'Punjabi', 'iso_639-1': 'pa', position: 86 },
  { id: 87, name: 'Polish', 'iso_639-1': 'pl', position: 87 },
  { id: 88, name: 'Pashto/Pushto', 'iso_639-1': 'ps', position: 88 },
  { id: 89, name: 'Portuguese', 'iso_639-1': 'pt', position: 89 },
  { id: 90, name: 'Quechua', 'iso_639-1': 'qu', position: 90 },
  { id: 91, name: 'Rhaeto-Romance', 'iso_639-1': 'rm', position: 91 },
  { id: 92, name: 'Kirundi', 'iso_639-1': 'rn', position: 92 },
  { id: 93, name: 'Romanian', 'iso_639-1': 'ro', position: 93 },
  { id: 94, name: 'Russian', 'iso_639-1': 'ru', position: 94 },
  { id: 95, name: 'Kinyarwanda', 'iso_639-1': 'rw', position: 95 },
  { id: 96, name: 'Sanskrit', 'iso_639-1': 'sa', position: 96 },
  { id: 97, name: 'Sindhi', 'iso_639-1': 'sd', position: 97 },
  { id: 98, name: 'Sangro', 'iso_639-1': 'sg', position: 98 },
  { id: 99, name: 'Serbo-Croatian', 'iso_639-1': 'sh', position: 99 },
  { id: 100, name: 'Singhalese', 'iso_639-1': 'si', position: 100 },
  { id: 101, name: 'Slovak', 'iso_639-1': 'sk', position: 101 },
  { id: 102, name: 'Slovenian', 'iso_639-1': 'sl', position: 102 },
  { id: 103, name: 'Samoan', 'iso_639-1': 'sm', position: 103 },
  { id: 104, name: 'Shona', 'iso_639-1': 'sn', position: 104 },
  { id: 105, name: 'Somali', 'iso_639-1': 'so', position: 105 },
  { id: 106, name: 'Albanian', 'iso_639-1': 'sq', position: 106 },
  { id: 107, name: 'Serbian', 'iso_639-1': 'sr', position: 107 },
  { id: 108, name: 'Siswati', 'iso_639-1': 'ss', position: 108 },
  { id: 109, name: 'Sesotho', 'iso_639-1': 'st', position: 109 },
  { id: 110, name: 'Sundanese', 'iso_639-1': 'su', position: 110 },
  { id: 111, name: 'Swedish', 'iso_639-1': 'sv', position: 111 },
  { id: 112, name: 'Swahili', 'iso_639-1': 'sw', position: 112 },
  { id: 113, name: 'Tamil', 'iso_639-1': 'ta', position: 113 },
  { id: 114, name: 'Telugu', 'iso_639-1': 'te', position: 114 },
  { id: 115, name: 'Tajik', 'iso_639-1': 'tg', position: 115 },
  { id: 116, name: 'Thai', 'iso_639-1': 'th', position: 116 },
  { id: 117, name: 'Tigrinya', 'iso_639-1': 'ti', position: 117 },
  { id: 118, name: 'Turkmen', 'iso_639-1': 'tk', position: 118 },
  { id: 119, name: 'Tagalog', 'iso_639-1': 'tl', position: 119 },
  { id: 120, name: 'Setswana', 'iso_639-1': 'tn', position: 120 },
  { id: 121, name: 'Tonga', 'iso_639-1': 'to', position: 121 },
  { id: 122, name: 'Turkish', 'iso_639-1': 'tr', position: 122 },
  { id: 123, name: 'Tsonga', 'iso_639-1': 'ts', position: 123 },
  { id: 124, name: 'Tatar', 'iso_639-1': 'tt', position: 124 },
  { id: 125, name: 'Twi', 'iso_639-1': 'tw', position: 125 },
  { id: 126, name: 'Ukrainian', 'iso_639-1': 'uk', position: 126 },
  { id: 127, name: 'Urdu', 'iso_639-1': 'ur', position: 127 },
  { id: 128, name: 'Uzbek', 'iso_639-1': 'uz', position: 128 },
  { id: 129, name: 'Vietnamese', 'iso_639-1': 'vi', position: 129 },
  { id: 130, name: 'Volapuk', 'iso_639-1': 'vo', position: 130 },
  { id: 131, name: 'Wolof', 'iso_639-1': 'wo', position: 131 },
  { id: 132, name: 'Xhosa', 'iso_639-1': 'xh', position: 132 },
  { id: 133, name: 'Yoruba', 'iso_639-1': 'yo', position: 133 },
  { id: 134, name: 'Chinese', 'iso_639-1': 'zh', position: 134 },
  { id: 135, name: 'Zulu', 'iso_639-1': 'zu', position: 135 }
]

const CONTACT_CATEGORIES = [
  {
    icon: 'people',
    text: 'Artwork acquisition source',
    path: '/contacts/artwork_acquisition_source',
    name: 'artwork_acquisition_source'
  },
  {
    icon: 'people',
    text: 'Device acquisition company',
    path: '/contacts/device_acquisition_company',
    name: 'device_acquisition_company'
  },
  {
    icon: 'people',
    text: 'Loan borrower',
    path: '/contacts/loan_borrower',
    name: 'loan_borrower'
  },
  {
    icon: 'people',
    text: 'Loan contact person',
    path: '/contacts/loan_contact_person',
    name: 'loan_contact_person'
  },
  {
    icon: 'people',
    text: 'Press registrant',
    path: '/contacts/press_registrant',
    name: 'press_registrant'
  },
  {
    icon: 'people',
    text: 'Newsletter registrant',
    path: '/contacts/newsletter_registrant',
    name: 'newsletter_registrant'
  },
  {
    icon: 'people',
    text: 'Loan insurance company',
    path: '/contacts/deaccession',
    name: 'deaccession'
  },
  {
    icon: 'people',
    text: 'Registrar',
    path: '/contacts/registrar',
    name: 'registrar'
  },
  { icon: 'people', text: 'Staff', path: '/contacts/staff', name: 'staff' },
  {
    icon: 'people',
    text: 'Staff external',
    path: '/contacts/staff_external',
    name: 'staff_external'
  },
  {
    icon: 'people',
    text: 'Trustee',
    path: '/contacts/trustee',
    name: 'trustee'
  }
]

const ACQUISITION_METHODS = [
  { id: 1, name: 'Purchase' },
  { id: 2, name: 'Auction sale' },
  { id: 3, name: 'Commission TBA21' },
  { id: 9, name: 'Commission TBA21-ACADEMY' },
  { id: 4, name: 'Gift' },
  { id: 5, name: 'Rededication' },
  { id: 7, name: 'Private Sale' },
  { id: 8, name: 'Unknown' }
]

const VISA_STATUSES = [
  { id: 1, name: 'NON EU' },
  { id: 2, name: 'EU' },
  { id: 3, name: 'FREEPORT' }
]

const OPTICAL_FILMS = [
  { id: 1, name: '8 mm' },
  { id: 2, name: '9.5 mm' },
  { id: 3, name: '16mm' },
  { id: 4, name: '35mm' },
  { id: 5, name: '70mm' },
  { id: 6, name: 'Slide' },
  { id: 7, name: 'Negative Small Format' },
  { id: 8, name: 'Medium Format' },
  { id: 9, name: 'Large Format' },
  { id: 10, name: 'Microfilm' },
  { id: 11, name: 'Other' }
]

const OPTICAL_DISCS = [
  { id: 1, name: 'Laser Disc' },
  { id: 2, name: 'DVD' },
  { id: 3, name: 'CD' },
  { id: 4, name: 'Other' }
]

const MECHANICAL = [
  { id: 1, name: 'vinyl record' },
  { id: 2, name: 'punch card' },
  { id: 3, name: '35mm' },
  { id: 4, name: 'Other' }
]

const MAGNETIC = [
  { id: 1, name: 'Open Reel (1/2“)' },
  { id: 2, name: 'Umatic' },
  { id: 3, name: 'Betacam/SP' },
  { id: 4, name: 'VHS' },
  { id: 5, name: 'Digital Betacam' },
  { id: 6, name: 'DV  (1/4“)' },
  { id: 7, name: 'HDCAM' },
  { id: 8, name: 'Other' }
]

const ELECTRONICAL = [
  { id: 1, name: 'USB' },
  { id: 2, name: 'Solid State Drive (SSD)' },
  { id: 3, name: 'Read Only Memory (ROM)' },
  { id: 4, name: 'Random Access Memory (RAM)' },
  { id: 5, name: 'EEPROM' },
  { id: 6, name: 'Other' }
]

const MATERIALS = [
  { id: 1, name: 'nitrate' },
  { id: 2, name: 'acetate' },
  { id: 3, name: 'polyester' },
  { id: 4, name: 'polycarbonate' },
  { id: 5, name: 'other polymer' },
  { id: 6, name: 'unknown' },
  { id: 7, name: 'glass' },
  { id: 8, name: 'metal' },
  { id: 9, name: 'paper' },
  { id: 10, name: 'Other' }
]

const VIDEO_SIGNALS = [
  { id: 1, name: 'FBAS' },
  { id: 2, name: 'Y/C (S-Video I Dub)' },
  { id: 3, name: 'YCrCb (digital)' },
  { id: 4, name: 'YPbPr (analog)' },
  { id: 5, name: 'RGB' },
  { id: 6, name: 'unknown' },
  { id: 7, name: 'Other' }
]

const AUDIO_SIGNALS = [
  { id: 1, name: 'Optical' },
  { id: 2, name: 'Magnetic' },
  { id: 3, name: 'Longitudinal' },
  { id: 4, name: 'FM' },
  { id: 5, name: 'PCM' },
  { id: 6, name: 'Dolby' },
  { id: 7, name: 'unknown' },
  { id: 8, name: 'Other' }
]

const GENERATIONS = [
  { id: 1, name: 'Camera Negative' },
  { id: 2, name: 'Camera Positive' },
  { id: 3, name: 'Inter positive' },
  { id: 4, name: 'Inter negative' },
  { id: 5, name: 'Revearsal' }
]

const STATUSES = [
  { id: 1, name: 'Artist\'s Original' },
  { id: 2, name: 'Master Physical' },
  { id: 3, name: 'Copy Master Physical' },
  { id: 4, name: 'Physical Access Copy' },
  { id: 5, name: 'Other' }
]

const SHELLS = [
  { id: 1, name: 'Signed by artist' },
  { id: 2, name: 'Designed by artist' },
  { id: 3, name: 'Non specific' }
]

const ATTACHEMENTS = [
  { id: 1, name: 'Certificate' },
  { id: 2, name: 'Dub sheet' },
  { id: 3, name: 'Vtr card' },
  { id: 4, name: 'Installation Instruction' },
  { id: 5, name: 'Contract' },
  { id: 6, name: 'Photos' }
]

const DAMAGE_TYPES = [
  { id: 1, name: 'Abrasions Creases' },
  { id: 2, name: 'Tear' },
  { id: 3, name: 'Residue Discoloration Distortion Water damage Scratch' },
  { id: 4, name: 'Tape' },
  { id: 5, name: 'Fading' },
  { id: 6, name: 'Mould' },
  { id: 7, name: 'Flaking' },
  { id: 8, name: 'Cracking' },
  { id: 9, name: 'Dent' },
  { id: 10, name: 'Puncture' },
  { id: 11, name: 'Surface Dirt' },
  { id: 12, name: 'Loss / Missing Area Smudge' },
  { id: 13, name: 'Parasite' },
  { id: 14, name: 'Adhesive Residue Stains' },
  { id: 15, name: 'Warping' },
  { id: 16, name: 'Brittle Yellowed Sticky Dust' }
]

const READING_DEVICE_TYPES = [
  { id: 1, name: 'computer' },
  { id: 2, name: 'micro_controller' },
  { id: 3, name: 'film_projector' },
  { id: 4, name: 'slide_projector' },
  { id: 5, name: 'video_tape_recorder' },
  { id: 6, name: 'linear_tape_drive' },
  { id: 7, name: 'disc_tape_drive' },
  { id: 8, name: 'dvd_player' },
  { id: 9, name: 'media_player' },
  { id: 10, name: 'other' }
]

const COMPUTERS = [
  { id: 1, name: 'Server' },
  { id: 2, name: 'Laptop' },
  { id: 3, name: 'Desktop' },
  { id: 4, name: 'Virtual' },
  { id: 5, name: 'Other' }
]

const MICRO_CONTROLLERS = [
  { id: 1, name: 'LCD' },
  { id: 2, name: 'LED-LCD' },
  { id: 3, name: 'Plasma' },
  { id: 4, name: 'Other' }
]

const FILM_PROJECTORS = [
  { id: 1, name: '8 mm' },
  { id: 2, name: '16mm' },
  { id: 3, name: '35mm' },
  { id: 4, name: 'Other' }
]

const SLIDE_PROJECTORS = [
  { id: 1, name: 'Single projecting' },
  { id: 2, name: 'Slate' },
  { id: 3, name: 'Carousel' },
  { id: 4, name: 'Other' }
]

const VIDEO_TAPE_RECORDERS = [
  { id: 1, name: 'Open Reel (1/2“)' },
  { id: 2, name: 'Umatic' },
  { id: 3, name: 'Betacam/SP' },
  { id: 4, name: 'VHS' },
  { id: 5, name: 'Digital Betacam' },
  { id: 6, name: 'DV (1/4“)' },
  { id: 7, name: 'HDCAM' },
  { id: 8, name: 'Other' }
]

const MONITORS = [
  { id: 1, title: 'LCD' },
  { id: 2, title: 'LED-LCD' },
  { id: 3, title: 'Plasma' },
  { id: 4, title: 'CRT' },
  { id: 5, title: 'Other' }
]

const PROJECTORS = [
  { id: 1, title: '8mm' },
  { id: 2, title: '16mm' },
  { id: 3, title: '35mm' },
  { id: 4, title: 'DLP' },
  { id: 5, title: 'CRT' },
  { id: 6, title: 'Other' }
]

const MOTORS = [
  { id: 1, title: 'electric motor' },
  { id: 2, title: 'pneumatic motor' },
  { id: 3, title: 'hydraulic motor' },
  { id: 4, title: 'Other' }
]

const BULBS = [
  { id: 1, title: 'Incandescent light bulb' },
  { id: 2, title: 'LED' },
  { id: 3, title: 'Halogen' },
  { id: 4, title: 'Arc lamp' },
  { id: 5, title: 'Gas-discharged lamp (fluorescent, neon)' },
  { id: 6, title: 'Other' }
]

const ORIGINS = [
  { id: 1, title: 'Unique' },
  { id: 2, title: 'Dedicated' },
  { id: 3, title: 'Historic Dedicated' },
  { id: 4, title: 'Non-dedicated' }
]

const CHANNELS = [
  { id: 1, value: '1', name: 'Single-channel' },
  { id: 2, value: '2', name: 'Two-channel' },
  { id: 3, value: '3', name: 'Three-channel' },
  { id: 4, value: '4', name: 'Four-channel' },
  { id: 5, value: '5', name: 'Five-channel' },
  { id: 6, value: '6', name: 'Six-channel' },
  { id: 7, value: '7', name: 'Seven-channel' },
  { id: 8, value: '8', name: 'Eight-channel' },
  { id: 9, value: '9', name: 'Nine-channel' },
  { id: 10, value: '10', name: 'Ten-channel' },
  { id: 11, value: '11', name: '11-channel' },
  { id: 12, value: '12', name: '12-channel' },
  { id: 13, value: '13', name: '13-channel' },
  { id: 14, value: '14', name: '14-channel' },
  { id: 15, value: '15', name: '15-channel' },
  { id: 16, value: '16', name: '16-channel' },
  { id: 17, value: '17', name: '17-channel' },
  { id: 18, value: '18', name: '18-channel' },
  { id: 19, value: '19', name: '19-channel' },
  { id: 20, value: '20', name: '20-channel' },
  { id: 21, value: '21', name: '21-channel' },
  { id: 22, value: '22', name: '22-channel' },
  { id: 23, value: '23', name: '23-channel' },
  { id: 24, value: '24', name: '24-channel' },
  { id: 25, value: '25', name: '25-channel' },
  { id: 26, value: '26', name: '26-channel' },
  { id: 27, value: '27', name: '27-channel' },
  { id: 28, value: '28', name: '28-channel' },
  { id: 29, value: '29', name: '29-channel' },
  { id: 30, value: '30', name: '30-channel' },
  { id: 31, value: '31', name: '31-channel' },
  { id: 32, value: '32', name: '32-channel' },
  { id: 33, value: '33', name: '33-channel' },
  { id: 34, value: '34', name: '34-channel' },
  { id: 35, value: '35', name: '35-channel' },
  { id: 36, value: '36', name: '36-channel' },
  { id: 37, value: '37', name: '37-channel' },
  { id: 38, value: '38', name: '38-channel' },
  { id: 39, value: '39', name: '39-channel' },
  { id: 40, value: '40', name: '40-channel' }
]

const AUDIO_RESOLUTIONS = [
  { id: 1, value: '1', name: '32 kHz' },
  { id: 2, value: '2', name: '44,1 kHz' },
  { id: 3, value: '3', name: '48 kHz' },
  { id: 4, value: '4', name: '96 kHz' },
  { id: 5, value: '5', name: '192 kHz' }
]

const AUDIO_BITS = [
  { id: 1, value: '1', name: '16 Bit' },
  { id: 2, value: '2', name: '20 Bit' },
  { id: 3, value: '3', name: '24 Bit' }
]

const INTERFACES = [
  { id: 1, name: 'composite' },
  { id: 2, name: 'component' },
  { id: 3, name: 'SVideo' },
  { id: 4, name: 'SDI' },
  { id: 5, name: 'VGA' },
  { id: 6, name: 'HDMI' },
  { id: 7, name: 'DVI' },
  { id: 8, name: 'IDE' },
  { id: 9, name: 'SATA' },
  { id: 10, name: 'USB 2.0' },
  { id: 11, name: 'USB 3.0' },
  { id: 12, name: 'FireWire' },
  { id: 13, name: 'Thunderbolt' },
  { id: 14, name: 'XLR Audio' },
  { id: 15, name: 'unknown' },
  { id: 16, name: 'other' }
]

// const CLASSIFICATIONS = [
//   { id: 1, title: 'pppd' },
//   { id: 2, title: 'fvs - digital born' },
//   { id: 3, title: 'fvs - tape' },
//   { id: 4, title: 'fvs - film' },
//   { id: 5, title: 'iao' },
//   { id: 6, title: 'iao including fvs - digital born' },
//   { id: 7, title: 'iao including fvs - tape' },
//   { id: 8, title: 'iao including fvs - film' },
//   { id: 9, title: 'arch' },
//   { id: 10, title: 'furn' }
// ]

// const CLASSIFICATIONS_TEMP = ['pppd', 'fvs', 'iao', 'arch', 'furn']

const TEXT_CATEGORIES = [
  { id: 'pr', name: 'PR' },
  { id: 'article', name: 'Article' },
  { id: 'artwork_text', name: 'Artwork Text' },
  { id: 'artist_documents', name: 'Artist Documents' },
  { id: 'transcript', name: 'Transcript' },
  { id: 'work_text', name: 'Work Text' },
  { id: 'notes', name: 'Notes' },
  { id: 'publication', name: 'Publication' }
]

const GENDERS = [
  { id: 'Male', value: 'Male', name: 'Male' },
  { id: 'Female', value: 'Female', name: 'Female' },
  { id: 'Non-binary', value: 'Non-binary', name: 'Non-binary' },
  { id: 'Transgender', value: 'Transgender', name: 'Transgender' }
]

// should not be used probably because we check for user rigts in the store and output my_ownerships
const OWNERSHIPS = [
  {
    id: 1,
    name: 'TBA21 Collection',
    role: 'coll'
  },
  {
    id: 12,
    name: 'Gemini Masters Limited',
    role: 'gemini'
  },
  {
    id: 15,
    name: 'Gemini Collections Limited',
    role: 'geminiCL'
  },
  // {
  //   id: 16,
  //   name: 'Gemini Collections Deaccessioned',
  //   role: 'geminiCD'
  //   // },
  //   // {
  //   //   id: 13,
  //   //   name: 'Baron Thyssen'
  //   // },
  //   // {
  //   //   id: 14,
  //   //   name: 'FTB'
  // },
  {
    id: 6,
    name: 'Private Art Collection FTB',
    role: 'pacFvh',
    an_ext: 'D'
  },
  {
    id: 7,
    name: 'Private Design Collection FTB',
    role: 'pdcFvh',
    an_ext: 'E'
  },
  {
    id: 20,
    name: 'Private Collection GH',
    role: 'pacGh',
    an_ext: 'GH'
  },
  {
    id: 17,
    name: 'Private Collection EH',
    role: 'pacEh',
    an_ext: 'EH'
  },
  {
    id: 21,
    name: 'Private Collection FH',
    role: 'pacFh',
    an_ext: 'FH'
  },
  {
    id: 10,
    name: 'Private Art Collection MR',
    role: 'pacMr',
    an_ext: 'MR'
  },
  {
    id: 'de',
    role: 'deac',
    name: 'Deaccession'
  },
  {
    id: '19',
    role: 'pcFT',
    name: 'Private Collection FT”'
  },
  // {
  //   id: 9,
  //   name: 'Old Masters',
  //   role: 'old_masters'
  // },
  {
    id: 11,
    name: 'Private Collection Casa Austria',
    role: 'pcCA',
    an_ext: 'CA'
  }
  // {
  //   id: 18,
  //   name: 'NON-TBA21',
  //   role: 'nonTba'
  // }
]

const ARTIST = {
  tabs: {
    public: {
      title: 'PUBLIC',
      key: 'public',
      component: 'VisibilitySettings'
    },
    basic: {
      title: 'Basic',
      key: 'basic',
      fields: {
        headline_names: {
          headline: true,
          title: 'Names',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        name: {
          ctype: 'text-short',
          name: 'name',
          title: 'Name',
          component: 'EditField',
          class: 'xs12'
        },
        first_name: {
          ctype: 'text-short',
          name: 'first_name',
          title: 'First Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        last_name: {
          ctype: 'text-short',
          name: 'last_name',
          title: 'Last Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        sort_name: {
          ctype: 'text-short',
          name: 'sort_name',
          title: 'Sort Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        birth_name: {
          ctype: 'text-short',
          name: 'birthname',
          title: 'Birth Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        headline_birth: {
          headline: true,
          title: 'Birth',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        birth_date: {
          ctype: 'date',
          name: 'birth_date',
          title: 'Birth Date',
          component: 'EditField',
          class: 'xs12 md6'
        },
        birth_place: {
          ctype: 'text-short',
          name: 'birthplace',
          title: 'Birth Place',
          component: 'EditField',
          class: 'xs12 md6'
        },
        birthdate_note: {
          ctype: 'text-long',
          name: 'birthdate_note',
          title: 'Birth Date Note',
          component: 'EditField',
          class: 'xs12'
        },
        headline_other: {
          headline: true,
          title: 'Other',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        death_date: {
          ctype: 'date',
          name: 'death_date',
          title: 'Death date',
          component: 'EditField',
          class: 'xs12 md6'
        },
        gender: {
          ctype: 'radio',
          name: 'gender',
          title: 'Gender',
          component: 'EditField',
          class: 'xs12 md6',
          selection: [
            { id: 1, value: 1, name: 'Male' },
            { id: 2, value: 2, name: 'Female' },
            { id: 3, value: 3, name: 'Non-binary' },
            { id: 4, value: 4, name: 'Transgender' }
          ]
        },
        headline_texts: {
          headline: true,
          title: 'Info',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        livesandworks: {
          ctype: 'text-long',
          name: 'livesandworks',
          title: 'Lives and works',
          component: 'EditField',
          class: 'xs12'
        },
        bio: {
          ctype: 'text-long',
          name: 'bio',
          title: 'Bio',
          component: 'EditField',
          class: 'xs12'
        }
      }
    },
    artworks: {
      title: 'Artworks',
      key: 'artworks',
      component: 'ViewArtworks'
    },
    multi_artist: {
      title: 'Collective',
      key: 'multi_artist',
      component: 'MultiArtist'
    }
  }
}

const COUNTRIES = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'Côte d\'Ivoire',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, Democratic People\'s Republic of',
  'Korea, Republic of',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the Former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'USA',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
]

const CURRENCIES = [
  'EUR',
  'USD',
  'GBP',
  'AUD',
  'CHF',
  'YEN',
  'MYR',
  'SIT',
  'MAD',
  'ATS (obsolete)',
  'DEM (obsolete)',
  'ESP (obsolete)',
  'FRF (obsolete)',
  'ITL (obsolete)',
  'NLG (obsolete)',
  'RM (obsolete)',
  'Gift',
]

export default {
  CURRENCIES: CURRENCIES,
  TOOLBAR_MENU_ITEMS: TOOLBAR_MENU_ITEMS,
  OWNERSHIP_STATUSES: OWNERSHIP_STATUSES,
  TYPES_OF_WORK: TYPES_OF_WORK,
  OWNERSHIPS: OWNERSHIPS,
  LANGUAGES: LANGUAGES,
  CONTACT_CATEGORIES: CONTACT_CATEGORIES,
  VISA_STATUSES: VISA_STATUSES,
  ACQUISITION_METHODS: ACQUISITION_METHODS,
  OPTICAL_FILMS: OPTICAL_FILMS,
  OPTICAL_DISCS: OPTICAL_DISCS,
  MECHANICAL: MECHANICAL,
  MAGNETIC: MAGNETIC,
  ELECTRONICAL: ELECTRONICAL,
  MATERIALS: MATERIALS,
  VIDEO_SIGNALS: VIDEO_SIGNALS,
  AUDIO_SIGNALS: AUDIO_SIGNALS,
  GENERATIONS: GENERATIONS,
  STATUSES: STATUSES,
  SHELLS: SHELLS,
  ATTACHEMENTS: ATTACHEMENTS,
  DAMAGE_TYPES: DAMAGE_TYPES,
  READING_DEVICE_TYPES: READING_DEVICE_TYPES,
  COMPUTERS: COMPUTERS,
  MICRO_CONTROLLERS: MICRO_CONTROLLERS,
  FILM_PROJECTORS: FILM_PROJECTORS,
  SLIDE_PROJECTORS: SLIDE_PROJECTORS,
  VIDEO_TAPE_RECORDERS: VIDEO_TAPE_RECORDERS,
  MONITORS: MONITORS,
  PROJECTORS: PROJECTORS,
  MOTORS: MOTORS,
  BULBS: BULBS,
  ORIGINS: ORIGINS,
  CHANNELS: CHANNELS,
  AUDIO_RESOLUTIONS: AUDIO_RESOLUTIONS,
  AUDIO_BITS: AUDIO_BITS,
  INTERFACES: INTERFACES,
  // CLASSIFICATIONS: CLASSIFICATIONS,
  // CLASSIFICATIONS_TEMP: CLASSIFICATIONS_TEMP,
  TEXT_CATEGORIES: TEXT_CATEGORIES,
  GENDERS: GENDERS,
  ARTIST: ARTIST,
  COUNTRIES: COUNTRIES,
  ARTWORK_FIELDS: ARTWORK_FIELDS
}



// WEBPACK FOOTER //
// ./src/data/constants.js